// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const actions: Record<string, any> = {};

type Actions = typeof actions;

export type { Actions };
